import React from 'react'

import { Auth } from '@edge/spark/io-aws'

import loadscript from './loadscript'
import useVisualizeHelper from './useVisualizeHelper'
import { useActiveAuctionId } from '@edge/spark/io-roles'
import { env } from '@edge/env'

const reportsVersion = env.REACT_APP_REPORTS_VERSION
const baseUrl = env.REACT_APP_REPORT_BASE_URL

if (!baseUrl) {
    throw new Error('No REPORT_BASE_URL')
}

const securityUrl = reportsVersion > 6 ? baseUrl : `${baseUrl}/j_spring_security_check`

const urls = baseUrl
    ? {
          security: `${securityUrl}`,
          share: `${baseUrl}/rest_v2/jobs`,
          visualize: `${baseUrl}/client/visualize.js`,
      }
    : undefined

export const useJasperLogin = (): void => {
    // May fire even if not using jaspersoft. TODO: Lazy login

    const auctionId = useActiveAuctionId()
    const { login } = useVisualizeHelper()

    React.useEffect(() => {
        ;(async () => {
            try {
                if (urls) {
                    await loadscript('JasperVisualizeJS', urls.visualize)
                    const token = await Auth.currentSession().then((s) => s.getAccessToken().getJwtToken())
                    const validToken = (await Auth.currentSession()).isValid()
                    if (typeof auctionId === 'string' && validToken) {
                        login(token, auctionId, urls.security)
                    } else {
                        const refreshToken = (await Auth.currentSession()).getRefreshToken().getToken()
                        login(refreshToken, auctionId, urls.security)
                    }
                }
            } catch (e) {
                console.error('useJasperLogin Error. Logout and retry again', e)
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
}
